/**
 * The illustrations the tablet can actually draw.
 *
 * **Shared with the Kids App and therefore contract-shaped, not app-shaped.**
 * `apps/kids/src/ui/artwork.tsx` holds the matching registry and falls back to a
 * neutral mark for anything it does not recognise. Offering a parent a choice
 * the tablet cannot render would produce a silent, invisible downgrade: they
 * pick a bear, the child gets a shrug, and nothing anywhere says why.
 *
 * So this list is deliberately the tablet's list and no longer. It lives here
 * only because track B may not edit `packages/contracts` — raised as a request
 * to track A, alongside the avatar vocabulary that has the same problem.
 */
export const ARTWORK_KEYS = ['bear', 'note', 'sun'] as const;

export type ArtworkKey = (typeof ARTWORK_KEYS)[number];

export const DEFAULT_ARTWORK_KEY: ArtworkKey = 'bear';
